import { ConsentRequestDto, EskatSessionDto } from '#modules/Eskat/Eskat.types'
import { ApiClient, platformService } from '@monthio/react-components'

class EskatApiClient {
	private apiClient = null as unknown as ApiClient
	private applicantDataApiClient = null as unknown as ApiClient

	public initialize() {
		this.apiClient = platformService.createApiClient(
			platformService.getAppUrl('eskatCoreApp'),
			{ appendApi: true },
		)

		this.applicantDataApiClient = platformService.createApiClient(
			platformService.getAppUrl('applicantDataApp'),
			{ appendApi: true },
		)
	}

	public getConsent = async (
		inputs: { useDemo: boolean } = { useDemo: false },
	) => {
		try {
			const response = await this.apiClient.get<ConsentRequestDto>(
				`consent?useDemoEnvironment=${inputs.useDemo}`,
			)
			return response
		} catch (error: any) {
			return Promise.reject(this.apiClient.mapError(error))
		}
	}

	public postTestData = async (demoProfile: string | null) => {
		try {
			const demoProfileQueryString =
				demoProfile !== null ? `?demoProfile=${demoProfile}` : ''
			await this.apiClient.post(`test-data${demoProfileQueryString}`)
		} catch (error: any) {
			return Promise.reject(this.apiClient.mapError(error))
		}
	}

	public fetchAndPersistEskatData = async () => {
		try {
			await this.apiClient.post(`eskat-sessions/fetch`)
			await this.callApplicantDataAppFinishModule()
		} catch (error: any) {
			return Promise.reject(this.apiClient.mapError(error))
		}
	}

	public registerEskatSession = async () => {
		try {
			const response = await this.apiClient
				.useCredentials('include')
				.get<EskatSessionDto>(`eskat-sessions/register`)
			return response
		} catch (error: any) {
			return Promise.reject(this.apiClient.mapError(error))
		}
	}

	private async callApplicantDataAppFinishModule(): Promise<void> {
		try {
			await this.applicantDataApiClient
				.timeout(5_000)
				.post(`session/finish-module-flow?moduleId=eskat`)
		} catch {
			// intentionally ignored
		}
	}
}

export const eskatApiClient = new EskatApiClient()
